import React, { Component } from 'react';
import Firebase from 'firebase';
import { DataTable } from 'react-data-components';
import EditUSer from './editUser'
import UserInfo from './userInfo'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
var ReactToastr = require("react-toastr");
var { ToastContainer } = ReactToastr;
var ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);

export default class userPrueba extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {}
        }
        this.updateUser = this.updateUser.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        var arrayDatos = []
        Object.keys(nextProps.users).map((u) => {
            var userRef = Firebase.database().ref('users').child(u)
                .once('value').then(resp => {
                    if (resp.val()) {
                        if (resp.val().last_online) {
                            var d = new Date(resp.val().last_online);
                            var yyyy = d.getFullYear().toString();
                            var mm = (d.getMonth() + 1).toString();
                            var dd = d.getDate().toString();
                            var hh = d.getHours().toString();
                            var mn = d.getMinutes().toString();
                        }
                        arrayDatos.push(
                            {
                                "Detalles": <div><button className="btn btn-info" onClick={() => { this.setState({ modal: true, user: resp.val() }) }} style={{ cursor: "pointer" }}>
                                    <i className="fa fa-info" aria-hidden="true"></i>
                                </button></div>,
                                Rut: resp.val().rut,
                                Nombre: resp.val().name,
                                Email: resp.val().email,
                                Número: resp.val().number ? resp.val().number : "No ingresado",
                                "Última conexión": resp.val().last_online ? yyyy + "/" + (mm[1] ? mm : "0" + mm[0]) + "/" + (dd[1] ? dd : "0" + dd[0]) + " " + (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]) : "No disponible",
                                "Acción": <div>
                                    <button className="btn btn-success" onClick={(e) => { this.setState({ showModalEdit: true, userId: u, user: resp.val() }) }} style={{ cursor: "pointer" }}>
                                        <i className="fa fa-pencil" aria-hidden="true"></i>
                                    </button>{" "}                    <button className="btn btn-danger" onClick={() => this.props.callBack(u, resp.val().name)} style={{ cursor: "pointer" }}>
                                        <i className="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                </div>
                            }
                        )
                        this.setState({ titulos: Object.keys(resp.val()) })
                    }
                });
        })
        this.setState({ users: arrayDatos })
    }

    update() {
        var arrayDatos = []
        Object.keys(this.props.users).map((u) => {
            var userRef = Firebase.database().ref('users').child(u)
                .once('value').then(resp => {
                    var d = new Date(resp.val().last_online);
                    var yyyy = d.getFullYear().toString();
                    var mm = (d.getMonth() + 1).toString();
                    var dd = d.getDate().toString();
                    var hh = d.getHours().toString();
                    var mn = d.getMinutes().toString();
                    arrayDatos.push(
                        {
                            "Detalles": <div>
                                <button className="btn btn-info" onClick={() => { this.setState({ modal: true, user: resp.val() }) }} style={{ cursor: "pointer" }}>
                                    <i className="fa fa-info" aria-hidden="true"></i>
                                </button>
                            </div>,
                            Rut: resp.val().rut,
                            Nombre: resp.val().name,
                            Email: resp.val().email,
                            Número: resp.val().number ? resp.val().number : "No ingresado",
                            "Última conexión": resp.val().last_online ? yyyy + "/" + (mm[1] ? mm : "0" + mm[0]) + "/" + (dd[1] ? dd : "0" + dd[0]) + " " + (hh[1] ? hh : "0" + hh[0]) + ':' + (mn[1] ? mn : "0" + mn[0]) : "No disponible",
                            "Acción": <button className="btn btn-success" onClick={(e) => { this.setState({ showModalEdit: true, userId: u, user: resp.val() }) }} style={{ cursor: "pointer" }}>
                                <i className="fa fa-pencil" aria-hidden="true"></i>
                            </button>
                        }
                    )
                    this.setState({ titulos: Object.keys(resp.val()) })
                });
        })
        this.setState({ users: arrayDatos })
    }


    updateUser() {
        this.setState({ showModalEdit: false });
        this.refs.container.success(
            "Usuario editado correctamente",
            "", {
                timeOut: 3000,
                extendedTimeOut: 10000
            });

        this.setState({ showModal: false });
        this.update();
    }


    render() {
        var titles = [
            { title: "Detalles", prop: "Detalles" },
            { title: "Rut", prop: "Rut" },
            { title: "Nombre", prop: "Nombre" },
            { title: "Email", prop: "Email" },
            { title: "Número", prop: "Número" },
            { title: "Última conexión", prop: "Última conexión" },
            { title: "Acción", prop: "Acción" }
        ];
        return (
            <div>
                <ToastContainer
                    style={{ top: "60" }}
                    ref="container"
                    toastMessageFactory={ToastMessageFactory}
                    className="toast-top-right"
                />
                {this.state.titulos ?
                    <DataTable
                        keys="id"
                        columns={titles}
                        initialData={this.state.users}
                        initialPageLength={15}
                        initialSortBy={{ prop: titles[0].prop, order: 'descending' }}
                        pageLengthOptions={[5, 20, 50, 100]}
                    />
                    : ""
                }
                <Modal isOpen={this.state.showModalEdit} toggle={() => { this.setState({ showModalEdit: false }) }} className="modal-content modal-lg">
                    <ModalHeader toggle={() => { this.setState({ showModalEdit: false }) }}>
                    </ModalHeader>
                    <ModalBody>
                        <EditUSer user={this.state.user} id={this.state.userId} callBack={this.updateUser} />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.modal} toggle={() => { this.setState({ modal: false }) }} className="modal-content modal-lg">
                    <ModalBody>
                        <UserInfo user={this.state.user} />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/users/userPrueba.js